import axios from 'axios'
// import store from '@/store'
import endpoints from '@/api/endpoints'
// import _ from 'lodash'

export default {
  async getTasks () {
    // need to ensure this call does not return tasks connected to wos/projects/estimates
    return axios.get(endpoints.tasks).then((response) => {
      return response.data
    })
  },
  async getEventTasks (eventID) {
    return axios.get(endpoints.tasks + '?event=' + eventID).then((response) => {
      return response.data
    })
  },
  async getAssignedTasks (userID) {
    return axios.get(endpoints.tasks + '?assigned_to=' + userID).then((response) => {
      return response.data
    })
  },
  async getManagedTasks (userID) {
    return axios.get(endpoints.tasks + '?task_manager=' + userID).then((response) => {
      return response.data
    })
  },
  async getTask (taskID) {
    return axios.get(endpoints.tasks + taskID + '/').then((response) => {
      return response.data
    })
  },
  async createTask (task) {
    return axios.post(endpoints.tasks, task).then((response) => {
      return response.data
    })
  },
  async updateTask (task) {
    return axios.patch(endpoints.tasks + task.id + '/', task).then((response) => {
      return response.data
    })
  },
  async deleteTask (taskID) {
    return axios.delete(endpoints.tasks + taskID + '/').then((response) => {
      return response.data
    })
  }
}
